<template>
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.18" cy="2.45933" r="1.68" stroke="#0D7BC4"/>
    <path d="M11.4545 2H6.00003C5.69878 2 5.45459
                 2.24419 5.45459 2.54544C5.45459 2.84669 5.69878 3.09088
                 6.00003 3.09088H11.4545C11.7557 3.09088 11.9999 2.84669 11.9999
                 2.54544C11.9999 2.24422 11.7557 2 11.4545 2Z" fill="#0D7BC4"/>
    <path d="M11.4545 7.45477H6.00003C5.69878 7.45477 5.45459 7.69899 5.45459
                 8.00021C5.45459 8.30144 5.69878 8.54566 6.00003 8.54566H11.4545C11.7557 8.54566 11.9999 8.30144
                 11.9999 8.00021C11.9999 7.69899 11.7557 7.45477 11.4545 7.45477Z" fill="#0D7BC4"/>
    <path d="M3.4365 6.52129L1.62071 8.31527L0.937819 7.6062C0.728308 7.3896 0.38288 7.38386
                 0.166281 7.59337C-0.0503173 7.80288 -0.0560583 8.14831 0.153453 8.36491L1.21925
                 9.47271C1.32088 9.5764 1.45968 9.6353 1.60488 9.63634H1.61143C1.75443 9.63589 1.89156
                 9.57929 1.99324 9.47871L4.20012 7.29692C4.42844 7.10042 4.45424 6.75601 4.25774 6.52769C4.06125
                 6.29937 3.71684 6.27358 3.48852 6.47007C3.47007 6.48597
                 3.45268 6.50307 3.4365 6.52129Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'CheckListIcon'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/CheckListIcon.vue